module.exports = __webpack_public_path__ + "img/exitHight.31ca3a6f.png";